import { Link, useParams } from "react-router-dom";
import { imgUrl, useThemes } from "@/lib/inspiration";
import { useSeo } from "@/lib/site";
import { NotFoundPage } from "@/pages/site/OtherPages";

export default function InspirationPage() {
  const { slug } = useParams();
  const { data: themes, isLoading } = useThemes();
  const t = themes?.find((x) => x.slug === slug);
  useSeo({
    title: t ? `Ideas de láminas: ${t.name} | LUMINA STUDIO` : "Inspiración | LUMINA STUDIO",
    description: t ? `Ideas para decorar con láminas metálicas personalizadas: ${t.description}` : "Ideas para decorar con láminas LUMINA.",
  });
  if (isLoading) return <div className="min-h-[60vh]" />;
  if (!t) return <NotFoundPage />;
  return (
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 py-14 sm:py-20">
      <Link to="/#inspirate" className="text-xs uppercase tracking-[0.16em] text-[#080808]/60 hover:text-[#080808]">← Inspírate con LUMINA</Link>
      <h1 data-testid="inspiration-title" className="mt-4 font-serif-display text-[34px] sm:text-[52px] font-medium leading-tight">{t.name}</h1>
      <p className="mt-3 text-base sm:text-lg text-[#080808]/70">{t.description}</p>
      <nav aria-label="Temáticas" className="mt-8 flex flex-wrap gap-2">
        {themes.map((x) => (
          <Link key={x.slug} to={`/inspiracion/${x.slug}`} data-testid={`inspiration-chip-${x.slug}`}
            className={`rounded-full border px-4 py-1.5 text-xs transition-colors ${x.slug === slug ? "border-[#080808] bg-[#080808] text-[#FAF8F4]" : "border-[#080808]/15 hover:border-[#080808]/50"}`}>{x.name}</Link>
        ))}
      </nav>
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {t.examples.map((e) => (
          <figure key={e.id} data-testid={`inspiration-example-${e.id}`} className="flex flex-col overflow-hidden rounded-[6px] border border-[#B18A4B]/35 bg-white">
            <img src={imgUrl(e.url)} alt={e.caption || t.name} loading="lazy" className="aspect-square w-full object-cover" />
            <figcaption className="flex flex-1 flex-col gap-4 p-5">
              {e.caption && <p className="text-sm text-[#080808]/70">{e.caption}</p>}
              <Link to="/personalizar" data-testid={`inspiration-example-${e.id}-create`}
                className="mt-auto inline-flex justify-center rounded-full bg-[#080808] px-6 py-3 text-[0.75rem] font-semibold uppercase tracking-[0.14em] text-[#FAF8F4] transition-colors hover:bg-[#B18A4B]">
                Crea la tuya con tus fotos
              </Link>
            </figcaption>
          </figure>
        ))}
      </div>
      <p className="mt-10 text-sm text-[#080808]/60">Las imágenes son ideas de inspiración: no se agregan a tu pedido. Tu lámina se crea con tus propias fotografías.</p>
    </div>
  );
}
